/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export {
  default as Text,
  RegularText,
  SemiBoldText,
  BoldText,
  BoldItalicText,
  ExtraBoldText,
  FontWeight,
  QuicksandLight,
  QuicksandRegular,
  QuicksandMedium,
  QuicksandSemiBold,
  QuicksandBold,
  FiraSansBold,
  FiraSansExtraLight,
} from './Text';
